var render, staticRenderFns
import script from "./check-code.vue?vue&type=script&lang=js&"
export * from "./check-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "check-code.vue"
export default component.exports